import Rebase from 're-base';
import firebase from 'firebase';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBj4b5S2GUWWz2blNukmuEeorqnOTm1wzQ",
    authDomain: "catch-of-the-day-big-fish.firebaseapp.com",
    databaseURL: "https://catch-of-the-day-big-fish-default-rtdb.europe-west1.firebasedatabase.app",
});

const base = Rebase.createClass(firebaseApp.database());

// Named export
export {firebaseApp};

// This is a default export
export default base;